var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBicycle = function SvgBicycle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 6.1377C15.9375 5.82275 15.8124 5.52071 15.5897 5.29801C15.367 5.07531 15.0649 4.9502 14.75 4.9502H11.7812L15.9375 12.0752",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 15.0439C17.5771 15.0439 18.9062 13.7148 18.9062 12.0752C18.9062 10.4356 17.5771 9.10645 15.9375 9.10645C14.2979 9.10645 12.9688 10.4356 12.9688 12.0752C12.9688 13.7148 14.2979 15.0439 15.9375 15.0439Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 15.0439C5.7021 15.0439 7.03125 13.7148 7.03125 12.0752C7.03125 10.4356 5.7021 9.10645 4.0625 9.10645C2.4229 9.10645 1.09375 10.4356 1.09375 12.0752C1.09375 13.7148 2.4229 15.0439 4.0625 15.0439Z",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 4.9502H6.14062L10.2969 12.0752",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1669 7.3252H7.52629L4.0625 12.0752",
    stroke: "#919191",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBicycle;